/**
 * Polar2 p2-clean-kit：将 US 占位 variant ID 解析为当前店铺真实 variant。
 * 依赖 window.__polar2KitProduct（由 oc-revamp-main-product 注入）。
 */
(function () {
  function variantBlob(variant) {
    return [variant.title, variant.option1, variant.option2, variant.option3]
      .filter(Boolean)
      .join(' ');
  }

  function matchMachineVariant(title, variants) {
    if (!title || !variants || !variants.length) return null;

    if (/50W/i.test(title) && /RF/i.test(title)) {
      return (
        variants.find(function (v) {
          var blob = variantBlob(v);
          return /50W/i.test(blob) && /RF/i.test(blob);
        }) || null
      );
    }

    if (/70W/i.test(title) && /Glass/i.test(title)) {
      return (
        variants.find(function (v) {
          var blob = variantBlob(v);
          return /70W/i.test(blob) && /Glass/i.test(blob);
        }) || null
      );
    }

    return null;
  }

  function pickVariant(product, item, machineButtons) {
    var variantId = Number(item.getAttribute('data-id'));
    var variant = (product.variants || []).find(function (v) {
      return Number(v.id) === variantId;
    });
    if (variant) return variant;

    if (item.hasAttribute('data-machine')) {
      var title = item.getAttribute('data-title') || '';
      var ctx = window.__polar2KitProduct;
      var pool =
        ctx && ctx.handle === product.handle && ctx.variants && ctx.variants.length
          ? ctx.variants
          : product.variants;

      variant = matchMachineVariant(title, pool);
      if (!variant && machineButtons && machineButtons.length) {
        var idx = machineButtons.indexOf(item);
        if (idx >= 0 && pool[idx]) variant = pool[idx];
      }
      return variant || null;
    }

    var available = (product.variants || []).filter(function (v) {
      return v.available !== false;
    });
    return available[0] || product.variants[0] || null;
  }

  function applyResolvedVariant(item, variant, productHandle) {
    item.setAttribute('data-id', String(variant.id));
    if (item.hasAttribute('data-machine') && productHandle) {
      item.setAttribute('data-url', '/products/' + productHandle + '?variant=' + variant.id);
      item.setAttribute('data-product-handle', productHandle);
    }
  }

  function fetchProductJson(handle) {
    return fetch('/products/' + handle + '.js?ts=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
    }).then(function (res) {
      if (!res.ok) return null;
      return res.json();
    });
  }

  function resolveProductForItem(item) {
    var handle = item.getAttribute('data-product-handle');
    if (!handle && item.hasAttribute('data-machine') && window.__polar2KitProduct) {
      handle = window.__polar2KitProduct.handle;
      item.setAttribute('data-product-handle', handle);
    }
    if (!handle) return Promise.resolve(null);

    return fetchProductJson(handle).then(function (product) {
      if (product) return product;
      if (item.hasAttribute('data-machine') && window.__polar2KitProduct) {
        return fetchProductJson(window.__polar2KitProduct.handle);
      }
      return null;
    });
  }

  window.OcP2KitResolver = {
    pickVariant: pickVariant,
    applyResolvedVariant: applyResolvedVariant,
    resolveProductForItem: resolveProductForItem,
    fetchProductJson: fetchProductJson,
  };
})();
